import React from 'react'
import PixelAnimatedImage from './pixel-animated-image'
import * as styles from '../styles/components/dynamic-image.module.scss'
import cx from 'classnames'

export interface DynamicImageProps {
    imageSrc: string
    altText?: string
    pixelate?: boolean
    imageLoadingMode?: 'lazy' | 'eager'
    className?: string
}

/** Wrapper for GatsbyImage offering functionality like applying the pixelation animation */
const DynamicImage = (props: DynamicImageProps) => {
    const { imageSrc, imageLoadingMode, altText = '', pixelate, className } = props
    const role = altText === '' ? 'decorative' : undefined

    if (pixelate) {
        return <div className={className}>
            <PixelAnimatedImage
                imageSrc={imageSrc}
                className={styles.image}
                alt={altText}
                role={role}
            />
        </div>
    }

    return (
        <div className={cx(styles.imgContainer, className)}>
            <img
                src={imageSrc}
                loading={imageLoadingMode}
                className={styles.image}
                alt={altText}
                role={role}
            />
        </div>
    )
}

export default DynamicImage
